import { Box, CircularProgress, Grid } from '@material-ui/core';
import { MerchantData } from '@nemuru-eng/js-api-client';
import React from 'react';

import { MerchantBrandingEditDialog } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantBranding/components/MerchantBrandingEditDialog';
import { MerchantBrandingForm } from '@/components/modules/MerchantDetail/MerchantOverview/components/MerchantBranding/components/MerchantBrandingForm';
import { ActionsOption } from '@/components/shared/components/MoreActionsMenu/types/ActionsOption';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const MerchantBranding: React.FC<{
  merchantId: string;
  merchantData?: MerchantData;
  merchantDataLoading?: boolean;
  editModeAllowed?: boolean;
}> = ({ merchantId, merchantData, merchantDataLoading, editModeAllowed = false }) => {
  const { opened, toggleDialog, setOpened } = useDialog();
  const { palette, customBorderRadius } = useCustomTheme();

  const actions: ActionsOption[] | undefined =
    editModeAllowed && merchantData
      ? [
          {
            display: <Text tId={!merchantData.brandInformation ? 'ADD_BRAND_INFORMATION' : 'EDIT_BRAND_INFORMATION'} />,
            onClick: toggleDialog,
            iconName: 'edit',
          },
        ]
      : undefined;

  return (
    <SubSectionWrapper title={'BRANDING'} specificActionsOptionsArray={actions}>
      {!merchantData?.brandInformation ? (
        <PendingDataWarning />
      ) : (
        <>
          <Grid container spacing={4}>
            <Grid item xs={12} lg={6}>
              <MerchantBrandingForm brandInformation={merchantData.brandInformation} fullWidth />
            </Grid>
            <Grid item xs={12} lg={6}>
              <Box
                display={'flex'}
                alignItems={'center'}
                justifyContent={'center'}
                height={'100%'}
                bgcolor={palette.grey[50]}
                borderRadius={customBorderRadius.paper}
              >
                {merchantDataLoading ? (
                  <CircularProgress color={'secondary'} size={20} />
                ) : (
                  <img
                    src={merchantData.brandInformation.brandLogoUrl}
                    width={'auto'}
                    size={'auto'}
                    alt={'merchant-brand-logo'}
                    style={{ maxHeight: '165px', maxWidth: '100%' }}
                  />
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      )}
      {
        <MerchantBrandingEditDialog
          opened={opened}
          setOpened={setOpened}
          toggleDialog={toggleDialog}
          merchantId={merchantId}
          brandInformation={merchantData?.brandInformation}
        />
      }
    </SubSectionWrapper>
  );
};
